import React from "react";
import { Container, SectionLabel } from "../components/ui-kit";
import PageHero from "../components/PageHero";
import { Cpu, CreditCard, FileText, Users, Activity, BarChart3, Database, Eye } from "lucide-react";

const ITEMS = [
  [Cpu, "Digital campaign management", "Every initiative is coordinated through a structured digital workflow with lifecycle controls."],
  [CreditCard, "Secure payments", "Server-verified transactions with provider abstraction — PayPal now, Stripe & Network International ready."],
  [FileText, "Digital receipts", "Professional PDF receipts with unique numbers and QR verification."],
  [Users, "Partner management", "Due diligence, verification status and agreement tracking for every partner."],
  [Activity, "Impact tracking", "Outcomes captured and reported against defined goals."],
  [BarChart3, "Reporting", "Financial and impact reporting with exports for partners and auditors."],
  [Database, "Data analytics", "Clean dashboards and analytics across programs, currencies and regions."],
  [Eye, "Transparency", "Public receipt verification and an internal audit trail for every action."],
];

export default function Technology() {
  return (
    <div>
      <PageHero
        label="Technology"
        title="Technology that makes impact visible"
        subtitle="Helping Hands is built on a legitimate technology backbone — not simply a donation collector. Our digital CSR infrastructure powers coordination, payments, reporting and transparency."
        crumbs={[{ label: "Technology" }]}
      />
      <section className="bg-white">
        <Container className="py-16">
          <SectionLabel>Digital CSR Infrastructure</SectionLabel>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-bold text-emerald-900">A complete platform for responsible impact</h2>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {ITEMS.map(([Icon, title, text]) => (
              <div key={title} className="rounded-2xl border border-emerald-900/10 bg-sand p-6">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-900 text-gold-light"><Icon className="h-5 w-5" /></div>
                <h3 className="mt-4 font-display text-lg font-bold text-emerald-900">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{text}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
